import flatten from 'flat';
import connection from './fr-FR/connection';

export default flatten({
  ...connection,
});
